import type {
  GetMachineQuery,
  GetMachineQueryVariables,
  GetMachinesQuery,
  GetMachinesQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_MACHINES: TypedDocumentNode<
  GetMachinesQuery,
  GetMachinesQueryVariables
> = gql`
  query GetMachines {
    machines {
      id
      userId
      name
      context
      initialContext
      config
      createdAt
      updatedAt
      machineInstances {
        id
        machineId
        context
        config
        state
        isComplete
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_MACHINE: TypedDocumentNode<
  GetMachineQuery,
  GetMachineQueryVariables
> = gql`
  query GetMachine($id: String!) {
    machine(id: $id) {
      id
      userId
      name
      context
      initialContext
      config
      createdAt
      updatedAt
      machineInstances {
        id
        machineId
        context
        config
        state
        isComplete
        createdAt
        updatedAt
      }
    }
  }
`;
